// authHelper.js (create this file)
export const getStaffIdFromToken = () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) return null;
    
    const payload = token.split('.')[1];
    const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
    const decodedPayload = JSON.parse(atob(paddedPayload));
    
    console.log('Token payload:', decodedPayload);
    return decodedPayload.id ? parseInt(decodedPayload.id) : null;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const getCurrentStaffId = () => {
  // Try localStorage first
  let staffId = localStorage.getItem('staffId');
  
  if (!staffId) {
    // If not in localStorage, extract from token
    staffId = getStaffIdFromToken();
    if (staffId) {
      localStorage.setItem('staffId', staffId.toString());
    }
  }
  
  return staffId ? parseInt(staffId) : null;
};